import React, { Component, Fragment } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { connect } from "react-redux";
import { getSingleUser } from "../../firebase/firebase.utils";
import {
  getOrderTrackingResultRedux,
  updateOrderApiRedux,
  deleteOrderApiRedux,
  updateOrdersWithPaymentLinkRedux,
  uploadCashInRedux,
} from "../../actions/index";
import { Link } from "react-router-dom";
import man from "../products/physical/plus image.jpeg";
import {
  create1688Order,
  get1688OrderDetails,
  get1688TrackingStatus,
  generate1688PaymentLink,
} from "../../actions/get1688Data";
import { notifyWarning, notifyError } from "../../utils/notify";

const getPaymentStatusStr = (paymentStatus) => {
  if (!paymentStatus) return "Not Paid";
  if (typeof paymentStatus === "string") return paymentStatus;
  const { paid = 0, total = 0 } = paymentStatus;
  if (paid <= 0) return "Not Paid";
  if (paid >= total) return "Paid";
  return "Partially Paid";
};

export class Datatable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedValues: [],
      myData: this.props.myData,
      userObj: null,
      productObj: null,
      amount: 0,
      method: "",
      paymentStatus: "",
      chineseOrderObj: null,
      chineseTrackingObj: null,
      selectedAddress: {},
      agentCarton: "",
      pickLoading: false,
    };
  }

  selectRow = (e, i) => {
    if (!e.target.checked) {
      this.setState({
        checkedValues: this.state.checkedValues.filter((item, j) => i !== item),
      });
    } else {
      this.state.checkedValues.push(i);
      this.setState({
        checkedValues: this.state.checkedValues,
      });
    }
  };

  getTotal = (payments) => {
    let total = 0;
    if (payments && payments.length > 0) {
      payments.map((payment) => {
        total += parseInt(payment.amount);
      });
    }
    return total;
  };

  handleRemoveRow = () => {
    const selectedValues = this.state.checkedValues;
    const updatedData = this.state.myData.filter(function (el) {
      return selectedValues.indexOf(el.id) < 0;
    });
    this.setState({
      myData: updatedData,
    });
    toast.success("Successfully Deleted !");
  };

  Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  getStatus = (productQuantity) => {
    if (productQuantity < 10) {
      return <i className="fa fa-circle font-danger f-12" />;
    } else if (productQuantity > 50) {
      return <i className="fa fa-circle font-success f-12" />;
    } else {
      return <i className="fa fa-circle font-warning f-12" />;
    }
  };
  getTotalPaid = (order) => {
    let totalPaid = 0;
    if (order.payments && order.payments.length > 0) {
      order.payments.map((paymnet) => {
        totalPaid += parseInt(paymnet.amount);
      });
    }
    return totalPaid;
  };

  getUserName = async (requestObj) => {
    const userObj = await getSingleUser(requestObj.userId);
    if (userObj) {
      this.setState({ userObj });
    } else {
    }
  };

  getTracing = (data) => {
    const formatted = Object.values(
      data.reduce((acc, curr) => {
        const [date, time] = curr.acceptTime.split(" ");
        if (!acc[date]) {
          acc[date] = { date, times: [] };
        }
        acc[date].times.push({ time, remark: curr.remark });
        return acc;
      }, {}),
    );
    return (
      <>
        {formatted.map((step, index) => {
          console.log(step);
          return (
            <div className="row" style={{ marginTop: index == 0 ? 0 : 20 }}>
              <div className="col-2" style={{ fontWeight: "bold" }}>
                {step.date}
              </div>
              <div className="col">
                {step.times.map((time, index) => (
                  <div
                    className="row"
                    style={{ marginTop: index == 0 ? 0 : 10 }}
                  >
                    <div className="col-2" style={{ color: "#666" }}>
                      {time.time}
                    </div>
                    <div
                      className="col-8"
                      style={{ color: "#888", fontWeight: "lighter" }}
                    >
                      {" "}
                      {time.remark}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </>
    );
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };
  handleSubmit = async (event, totalDue) => {
    event.preventDefault();
    const { productObj } = this.state;
    const { currentAdmin } = this.props;
    // if (this.state.amount == 0) {
    //   alert("Paid amount must be more than 0");
    //   return;
    // }
    // if (this.state.amount > totalDue) {
    //   alert("Paid amount can't be more than due amount.");
    //   return;
    // }
    console.log(this.state);

    await this.props.updateOrderApiRedux({
      ...this.state.productObj,
      paymentStatus:
        this.state.paymentStatus !== ""
          ? this.state.paymentStatus
          : getPaymentStatusStr(this.state.productObj.paymentStatus),
      payments:
        this.state.productObj.payments &&
        this.state.productObj.payments.length > 0
          ? [
              ...this.state.productObj.payments,
              {
                amount: this.state.amount,
                method: this.state.method,

                receivedBy: this.props.currentAdmin.name,
                date: new Date().toLocaleDateString("en-GB"),
              },
            ]
          : [
              {
                amount: this.state.amount,
                method: this.state.method,
                receivedBy: this.props.currentAdmin.name,
                date: new Date().toLocaleDateString("en-GB"),
              },
            ],
    });

    let date = new Date();

    let cashInObj = {
      id: date.getTime().toString(),
      category: "1688 Order",
      subCategory: this.state.method,
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      note: `Order Id: ${this.state.productObj.orderId}   User: ${
        this.state.productObj.displayName || "Guest"
      }`,
      amount: this.state.amount,
      receiveBy: currentAdmin.name,
      status: "pending",
      unEditable: true,
    };

    await this.props.uploadCashInRedux(cashInObj);

    toast.success("successfully updated the payment");

    this.setState({
      checkedValues: [],
      myData: this.props.myData,
      productObj: null,
      method: "",
      amount: "",
    });
    document.getElementById("close-button-for-payment-modal").click();
  };

  getTotalDue = (order) => {
    let totalPaid = 0;
    let totalDue = 0;
    let totalBill = 0;
    if (order.payments && order.payments.length > 0) {
      order.payments.map((paymnet) => {
        totalPaid += parseInt(paymnet.amount);
      });
    }
    const delivery = order.deliveryCharge ? parseInt(order.deliveryCharge) : 0;
    if (order.shippingChargeCustomer && order.shippingChargeCustomer != 0) {
      totalBill = order.orderTotal
        ? parseInt(order.orderTotal) +
          parseInt(order.shippingChargeCustomer) +
          (order.localShipping ? parseInt(order.localShipping) : 0) +
          delivery
        : this.getSingleShopTotal(order) +
          parseInt(order.shippingChargeCustomer) +
          (order.localShipping ? parseInt(order.localShipping) : 0) +
          delivery;
    } else {
      totalBill = order.orderTotal
        ? parseInt(order.orderTotal) + delivery
        : this.getSingleShopTotal(order) + delivery;
    }
    totalDue = parseInt(totalBill) - parseInt(totalPaid);
    return totalDue;
  };

  dateFormatter = (raw) => {
    // Extract parts from the string
    const year = raw.slice(0, 4);
    const month = raw.slice(4, 6);
    const day = raw.slice(6, 8);
    const hour = raw.slice(8, 10);
    const minute = raw.slice(10, 12);
    const second = raw.slice(12, 14);
    // milliseconds and timezone are ignored for display

    const formatted = `${year}-${month}-${day} ${hour}:${minute}:${second}`;

    return formatted;
  };

  render() {
    const {
      pageSize,
      myClass,
      multiSelectOption,
      pagination,
      currency,
      orderTracking,
      currentAdmin,
      shippingAddress,
    } = this.props;
    console.log(this.props);
    const { myData } = this.props;
    const { productObj, chineseOrderObj, chineseTrackingObj } = this.state;
    console.log(myData);
    const newData = [];
    if (myData.length > 0) {
      myData.forEach((order) => {
        newData.push({
          Date: order ? order.orderedDate : "",
          "Order Id": order ? order.orderId : "",
        });
      });
    }
    console.log(shippingAddress);
    console.log(productObj);
    // `orderTotal` is not reliable as a base for the payable total — on some
    // orders it excludes deliveryCharge, on others it already has it baked
    // in (double-counting it if added again below). actualTotal (Product
    // Price) is consistently the pre-delivery, pre-discount product subtotal
    // across every order, so every deduction/addition is computed from it
    // directly instead, mirroring each line actually shown in the Price
    // Breakdown. China Shipping (local) is informational only and is
    // deliberately excluded from the payable total.
    // "Price After Discount" — Product Price minus coupon/offer discounts,
    // matching the same subtotal checkpoint shown (bold) in the Price
    // Breakdown, just before delivery/packaging/shipping are added below.
    let priceAfterDiscount = 0;
    if (productObj) {
      const offerDiscount =
        productObj.offer && productObj.offer !== 0
          ? Math.round(
              (productObj.actualTotalAfterCoupon || 0) *
                (parseFloat(productObj.offer) / 100),
            )
          : 0;
      priceAfterDiscount =
        parseInt(productObj.actualTotal || 0) -
        (productObj.couponAmount ? parseInt(productObj.couponAmount) : 0) -
        offerDiscount;
    }
    let totalPayableAmount = 0;
    if (productObj) {
      totalPayableAmount =
        priceAfterDiscount +
        (productObj.otherCost ? parseInt(productObj.otherCost) : 0) -
        (productObj.discount ? parseInt(productObj.discount) : 0);
    }
    let totalPaid = 0;
    if (productObj && productObj.payments && productObj.payments.length > 0) {
      productObj.payments.map((payment) => {
        totalPaid += parseInt(payment.amount);
      });
    }
    if (!totalPayableAmount) {
      totalPayableAmount = 0;
    }
    let totalPayableAmountIncludingShipping = 0;
    if (productObj) {
      totalPayableAmountIncludingShipping =
        parseInt(totalPayableAmount) +
        (productObj.shippingChargeCustomer
          ? parseInt(productObj.shippingChargeCustomer)
          : 0) +
        (productObj.deliveryCharge ? parseInt(productObj.deliveryCharge) : 0);
    }
    let totalRmbAmount = 0;

    if (productObj && productObj.items) {
      productObj.items.map((item) => {
        item.skus.map((sku) => {
          totalRmbAmount +=
            parseFloat(sku.priceRMB) * parseInt(sku.totalQuantity);
        });
      });
    }
    const colHeaderStyle = {
      background: "#f0f4f8",
      color: "#444",
      fontWeight: 700,
      fontSize: 12,
      textTransform: "uppercase",
      letterSpacing: 0.5,
      padding: "10px 8px",
    };
    const pill = (text, bg, extra = {}) => (
      <span
        style={{
          display: "inline-block",
          background: bg,
          color: "white",
          borderRadius: 20,
          fontSize: 11,
          fontWeight: 600,
          padding: "3px 10px",
          letterSpacing: 0.3,
          ...extra,
        }}
      >
        {text}
      </span>
    );

    const columns = [];
    for (var key in newData[0]) {
      columns.push({
        Header: <div style={colHeaderStyle}>{this.Capitalize(key.toString())}</div>,
        accessor: key,
        Cell: null,
        style: { textAlign: "center", verticalAlign: "middle" },
      });
    }

    columns.push(
      {
        Header: <div style={colHeaderStyle}>User</div>,
        id: "col-user",
        accessor: (str) => "col-user",
        Cell: (row) => {
          const requestObj = myData.find(
            (request) => request.orderId == row.original["Order Id"],
          );

          return (
            <>
              {myData.length > 0 ? (
                <div style={{ textAlign: "left", lineHeight: 1.6 }}>
                  {(() => {
                    const { allUsers } = this.props;
                    const registeredUser =
                      allUsers &&
                      allUsers.find((u) => u.uid === requestObj.userId);
                    return (
                      <div
                        style={{
                          cursor: registeredUser ? "pointer" : "default",
                          color: registeredUser ? "#18768f" : "#aaa",
                          fontWeight: 600,
                          fontSize: 12,
                          marginBottom: 4,
                        }}
                        onClick={() => {
                          if (!registeredUser) return;
                          if (currentAdmin && currentAdmin.status == "Partner")
                            return;
                          this.props.history.push(
                            `${process.env.PUBLIC_URL}/users/list-user/${requestObj.userId}`,
                          );
                        }}
                      >
                        {registeredUser
                          ? `${registeredUser.uid}${registeredUser.displayName ? " · " + registeredUser.displayName : ""}`
                          : "Guest"}
                      </div>
                    );
                  })()}
                  <div style={{ fontSize: 11, color: "#555" }}>
                    👤 {requestObj.deliveryAddress?.fullName}
                  </div>
                  <div style={{ fontSize: 11, color: "#555" }}>
                    📞 {requestObj.deliveryAddress?.mobileNo}
                  </div>
                  <div style={{ fontSize: 11, color: "#777" }}>
                    📍 {requestObj.deliveryAddress?.address}
                  </div>
                  <div style={{ fontSize: 11, color: "#777" }}>
                    {requestObj.deliveryAddress?.district}
                  </div>
                </div>
              ) : (
                ""
              )}
            </>
          );
        },
        style: { textAlign: "center", verticalAlign: "middle" },
        sortable: false,
      },
      {
        Header: <div style={colHeaderStyle}>Total (Customer)</div>,
        id: "col-total-customer",
        accessor: (str) => "col-total-customer",
        Cell: (row) => {
          const requestObj = myData.find(
            (order) => order.orderId == row.original["Order Id"],
          );
          let total1688 = null;
          let shipping1688 = null;

          if (
            requestObj &&
            requestObj.creationTime1688 &&
            requestObj.creationTime1688.totalSuccessAmount
          ) {
            total1688 = requestObj.creationTime1688.totalSuccessAmount;
            shipping1688 = requestObj.creationTime1688.postFee;
          }
          let totalProfit =
            requestObj.orderTotal +
            (requestObj.localShipping
              ? parseFloat(requestObj.localShipping)
              : 0) -
            (total1688 && total1688 * requestObj.exchangeRate
              ? parseFloat(total1688 * requestObj.exchangeRate)
              : 0);

          return (
            <div style={{ textAlign: "center", lineHeight: 1.8 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: "#333" }}>
                {requestObj.orderTotal} Tk
              </div>
              <div style={{ color: "#888", fontSize: 11 }}>
                Post fee: {requestObj.localShipping ? requestObj.localShipping : 0} Tk
              </div>
              <div style={{ color: "#888", fontSize: 11 }}>
                Weight:{" "}
                {requestObj.items && requestObj.items[0]
                  ? requestObj.items[0].weight
                  : 0}{" "}
                kg
              </div>
              <div
                style={{
                  marginTop: 6,
                  fontSize: 11,
                  fontWeight: 600,
                  color: totalProfit >= 0 ? "#28a745" : "#dc3545",
                }}
              >
                Profit: {parseFloat(totalProfit).toFixed(2)} Tk
              </div>
            </div>
          );
        },
        style: { textAlign: "center", verticalAlign: "middle" },
        sortable: false,
      },
      {
        Header: <div style={colHeaderStyle}>Total (1688)</div>,
        id: "col-total-1688",
        accessor: (str) => "col-total-1688",
        Cell: (row) => {
          const requestObj = myData.find(
            (order) => order.orderId == row.original["Order Id"],
          );
          let total1688 = null;
          let shipping1688 = null;

          if (
            requestObj &&
            requestObj.creationTime1688 &&
            requestObj.creationTime1688.totalSuccessAmount
          ) {
            total1688 = requestObj.creationTime1688.totalSuccessAmount;
            shipping1688 = requestObj.creationTime1688.postFee;
          }
          return (
            <>
              {total1688 ? (
                <div style={{ textAlign: "center", lineHeight: 1.8 }}>
                  <div style={{ fontWeight: 700, fontSize: 14, color: "#5e72e4" }}>
                    ¥ {total1688}
                  </div>
                  <div style={{ color: "#888", fontSize: 11 }}>
                    Post fee: ¥ {shipping1688 ? shipping1688 : 0}
                  </div>
                  <div style={{ color: "#888", fontSize: 11 }}>
                    {total1688 && total1688 * requestObj.exchangeRate
                      ? parseFloat(total1688 * requestObj.exchangeRate).toFixed(2)
                      : 0}{" "}
                    Tk
                  </div>
                  <div style={{ fontSize: 11, color: "#aaa", marginTop: 4 }}>
                    Rate: {requestObj.exchangeRate ? requestObj.exchangeRate : 0} Tk/¥
                  </div>
                </div>
              ) : null}
            </>
          );
        },
        style: { textAlign: "center", verticalAlign: "middle" },
        sortable: false,
      },
      {
        Header: <div style={colHeaderStyle}>Order Number</div>,
        id: "col-order-number",
        accessor: (str) => "col-order-number",
        Cell: (row) => {
          const requestObj = myData.find(
            (order) => order.orderId == row.original["Order Id"],
          );
          const badge = pill(
            requestObj.orderNumber || "Not Ordered",
            requestObj.orderNumber ? "#ff5b00" : "#bbb",
          );
          return (
            <>
              {currentAdmin && currentAdmin.status == "Partner" ? (
                badge
              ) : (
                <div
                  style={{ cursor: "pointer" }}
                  data-toggle={
                    requestObj.orderNumber
                      ? "modal"
                      : this.props.orderStatus == "picked-orders"
                        ? "modal"
                        : ""
                  }
                  data-target={
                    requestObj.orderNumber
                      ? "#chineseOrderModal"
                      : this.props.orderStatus == "picked-orders"
                        ? "#pickModal"
                        : ""
                  }
                  onClick={async () => {
                    let chineseOrderObj2 = null;
                    if (requestObj.orderNumber) {
                      chineseOrderObj2 = await get1688OrderDetails(
                        requestObj.orderNumber,
                      );
                    }

                    this.setState({
                      productObj: requestObj,
                      chineseOrderObj: chineseOrderObj2,
                    });
                  }}
                >
                  {badge}
                </div>
              )}
            </>
          );
        },
        style: { textAlign: "center", verticalAlign: "middle" },
        sortable: false,
      },
      {
        Header: <div style={colHeaderStyle}>Tracking No</div>,
        id: "col-tracking",
        accessor: (str) => "col-tracking",
        Cell: (row) => {
          const requestObj = myData.find(
            (order) => order.orderId == row.original["Order Id"],
          );
          const badge = pill(
            requestObj.trackingNo || "Waiting",
            requestObj.trackingNo ? "#17a2b8" : "#bbb",
          );
          return (
            <>
              {currentAdmin && currentAdmin.status == "Partner" ? (
                badge
              ) : (
                <div
                  style={{ cursor: requestObj.trackingNo ? "pointer" : "default" }}
                  data-toggle={requestObj.trackingNo ? "modal" : ""}
                  data-target={requestObj.trackingNo ? "#trackingModal" : ""}
                  onClick={async () => {
                    if (requestObj.trackingNo) {
                      let trackingArray = await get1688TrackingStatus(
                        requestObj.orderNumber,
                      );
                      let trackingObj = trackingArray[0];
                      console.log(requestObj.orderNumber);
                      console.log(trackingObj);
                      this.setState({
                        productObj: requestObj,
                        chineseTrackingObj: trackingObj,
                      });
                    }
                  }}
                >
                  {badge}
                </div>
              )}
            </>
          );
        },
        style: { textAlign: "center", verticalAlign: "middle" },
        sortable: false,
      },
      {
        Header: <div style={colHeaderStyle}>Payment Status</div>,
        id: "col-payment-status",
        accessor: (str) => "col-payment-status",
        Cell: (row) => {
          const requestObj = myData.find(
            (order) => order.orderId == row.original["Order Id"],
          );
          const statusStr = getPaymentStatusStr(requestObj.paymentStatus);
          const bg =
            statusStr === "Partially Paid" ? "#fd7e14"
            : statusStr === "Not Paid" ? "#dc3545"
            : statusStr === "Paid" ? "#28a745"
            : statusStr === "purchaseLater" ? "#6c757d"
            : statusStr === "pending" ? "#fd7e14"
            : "#dc3545";
          const badge = pill(statusStr, bg);
          return (
            <>
              {currentAdmin && currentAdmin.status == "Partner" ? (
                badge
              ) : (
                <div
                  style={{ cursor: "pointer" }}
                  data-toggle="modal"
                  data-target="#paymentModal"
                  onClick={() => {
                    this.setState({ productObj: requestObj });
                  }}
                >
                  {badge}
                </div>
              )}
            </>
          );
        },
        style: { textAlign: "center", verticalAlign: "middle" },
        sortable: false,
      },
      {
        Header: <div style={colHeaderStyle}>Order Status</div>,
        id: "col-order-status",
        accessor: (str) => "col-order-status",
        Cell: (row) => {
          const requestObj = myData.find(
            (order) => order.orderId == row.original["Order Id"],
          );
          const statusColors = {
            pending: "#6c757d",
            order_pending: "#6c757d",
            Purchased: "#17a2b8",
            "Received in Warehouse": "#20c9e7",
            "Ready for fly": "#6f42c1",
            "Bangladesh customs": "#e9534f",
            "Bangladesh warehouse": "#28a745",
            "Zapai warehouse": "#00b300",
            Delivered: "#007900",
            Reject: "#dc3545",
          };
          const bg = requestObj
            ? statusColors[requestObj.orderStatus] || "#dc3545"
            : "#aaa";
          const label =
            requestObj.orderStatus === "order_pending"
              ? "pending"
              : requestObj.orderStatus;
          return pill(label, bg);
        },
        style: { textAlign: "center", verticalAlign: "middle" },
        sortable: false,
      },
      {
        Header: <div style={colHeaderStyle}>Order Details</div>,
        id: "col-details",
        accessor: (str) => "col-details",
        Cell: (row) => {
          const requestObj = myData.find(
            (order) => order.orderId == row.original["Order Id"],
          );
          return (
            <button
              style={{
                background: "linear-gradient(135deg, #00254c, #18768f)",
                color: "white",
                border: "none",
                borderRadius: 6,
                padding: "5px 14px",
                fontSize: 12,
                fontWeight: 600,
                cursor: "pointer",
              }}
              data-toggle="modal"
              data-target="#detailInfoModal"
              onClick={async () => {
                this.setState({
                  productObj: requestObj,
                });
                let orderTracking2 =
                  await this.props.getOrderTrackingResultRedux(
                    requestObj.trackingNo,
                  );
                console.log(orderTracking2);
                if (orderTracking2) {
                  this.props.updateOrderApiRedux({
                    ...requestObj,
                    shippingMark: orderTracking2.parcelsArray.map(
                      (parcel) => `${parcel.shippingMark}`,
                    ),
                    cargoCompany: "ALG Limited",
                    lotNo: orderTracking2.lotArray.map((lot) => `${lot}`),
                    ctnNo: orderTracking2.parcelsArray.map(
                      (parcel) => `${parcel.parcelId}`,
                    ),
                    cargoRate: orderTracking2.parcelsArray.map((parcel) => {
                      if (parcel.ratePerKg) {
                        return `${parcel.ratePerKg} tk/kg`;
                      } else {
                        return "Not given yet";
                      }
                    }),
                    shippingChargeCargo: orderTracking2.parcelsArray.map(
                      (parcel) => {
                        if (parcel.finalTotal) {
                          return `${parcel.finalTotal} Tk`;
                        } else {
                          return "Not given yet";
                        }
                      },
                    ),
                  });
                }
              }}
            >
              View
            </button>
          );
        },
        style: { textAlign: "center", verticalAlign: "middle" },
        sortable: false,
      },

      {
        Header: <div style={colHeaderStyle}>Invoice</div>,
        id: "col-invoice",
        accessor: (str) => "col-invoice",
        Cell: (row) => {
          const order = myData.find(
            (order) => order.orderId == row.original["Order Id"],
          );
          return (
            <>
              {currentAdmin && currentAdmin.status == "Partner" ? (
                <></>
              ) : (
                <Link
                  to={`${process.env.PUBLIC_URL}/pages/dashboard/buy-and-ship-for/invoice/${order.orderId}`}
                  target="_blank"
                >
                  {pill("Invoice", "#a3422b")}
                </Link>
              )}
            </>
          );
        },
        style: { textAlign: "center", verticalAlign: "middle" },
        sortable: false,
      },
      {
        Header: <div style={colHeaderStyle}>Process</div>,
        id: "col-process",
        accessor: (str) => "col-process",
        Cell: (row) => {
          const order = myData.find(
            (order) => order.orderId == row.original["Order Id"],
          );
          return (
            <>
              {order.agentId ? (
                <div
                  onClick={() => { this.setState({ productObj: order }); }}
                  style={{ cursor: "pointer" }}
                >
                  {pill("✅ Picked", "#28a745")}
                </div>
              ) : (
                <>
                  {currentAdmin && currentAdmin.status == "Partner" ? (
                    pill("✍ Pick", "#fd7e14")
                  ) : (
                    <div
                      onClick={async () => { this.setState({ productObj: order }); }}
                      style={{ cursor: "pointer" }}
                      data-toggle="modal"
                      data-target="#pickModal"
                    >
                      {pill("✍ Pick", "#fd7e14")}
                    </div>
                  )}
                </>
              )}
            </>
          );
        },
        style: { textAlign: "center", verticalAlign: "middle" },
        sortable: false,
      },
      {
        Header: <div style={colHeaderStyle}>Update</div>,
        id: "col-update",
        accessor: (str) => "col-update",
        Cell: (row) => {
          const order = myData.find(
            (order) => order.orderId == row.original["Order Id"],
          );
          return (
            <>
              {currentAdmin && currentAdmin.status == "Partner" ? (
                <></>
              ) : (
                <div style={{ display: "flex", justifyContent: "center", gap: 4 }}>
                  {order?.agentStatus == "Picked" && (
                    <span
                      style={{
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        background: "#e8f5e9",
                      }}
                      onClick={() => {
                        const order = myData.find(
                          (order) => order.orderId == row.original["Order Id"],
                        );
                        this.props.startToggleModal(order);
                      }}
                    >
                      <i className="fa fa-pencil" style={{ fontSize: 14, color: "#28a745" }}></i>
                    </span>
                  )}
                  {this.props.orderStatus == "new" && (
                    <span
                      style={{
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        background: "#fdecea",
                      }}
                      data-toggle="modal"
                      data-target="#deleteModal"
                      onClick={() => {
                        const order = myData.find(
                          (order) => order.orderId == row.original["Order Id"],
                        );
                        this.setState({ productObj: order });
                      }}
                    >
                      <i className="fa fa-trash" style={{ fontSize: 14, color: "#dc3545" }}></i>
                    </span>
                  )}
                </div>
              )}
            </>
          );
        },
        style: { textAlign: "center", verticalAlign: "middle" },
        sortable: false,
      },

      {
        Header:
          this.state.checkedValues.length > 0 ? (
            <button
              className="btn btn-sm btn-delete mb-0 b-r-4"
              style={{ backgroundColor: "purple", color: "white" }}
              role="button"
              data-toggle="modal"
              data-target="#request_payment"
              onClick={() => {
                console.log(this.state.checkedValues);
                let ordersToPay = myData.filter((order) =>
                  this.state.checkedValues.includes(order.orderId),
                );
                console.log(myData);

                console.log(ordersToPay);
                let totalRmbToPay = 0;
                ordersToPay.map((order) => {
                  totalRmbToPay += parseFloat(
                    order.creationTime1688.totalSuccessAmount,
                  );
                });
                this.setState({
                  checkedValues: [],
                  orders: ordersToPay,
                  totalRmbToPay: parseFloat(totalRmbToPay).toFixed(2),
                  link: null,
                });
              }}
            >
              Pay
            </button>
          ) : (
            <button
              style={{
                backgroundColor: "gray",
                color: "white",
                padding: "10px",
                border: "none",
                borderRadius: "5px",
              }}
              onClick={() => notifyWarning("Please choose an order first")}
            >
              multiple pay
            </button>
          ),
        id: "col-pay",
        accessor: (str) => "col-pay",
        sortable: false,
        style: {
          textAlign: "center",
        },
        Cell: (row) => {
          const parcelObj = myData.find(
            (parcel) => parcel.orderId == row.original["Order Id"],
          );
          return (
            <div>
              <span>
                {parcelObj.orderNumber &&
                this.props.orderStatus == "picked-orders" &&
                !parcelObj.paymentLink1688 ? (
                  <input
                    type="checkbox"
                    style={{ height: 25, width: 25 }}
                    name={row.original["Order Id"]}
                    checked={this.state.checkedValues.includes(
                      row.original["Order Id"],
                    )}
                    onChange={(e) =>
                      this.selectRow(e, row.original["Order Id"])
                    }
                  />
                ) : null}
              </span>
            </div>
          );
        },
        accessor: key,
        style: {
          textAlign: "center",
        },
      },
    );

    console.log(chineseTrackingObj);

    return (
      <Fragment>
        <div style={{ overflowX: "auto" }}>
          <ReactTable
            data={newData}
            columns={columns}
            defaultPageSize={pageSize}
            className={myClass}
            showPagination={pagination}
            style={{ border: "none" }}
            getTheadThProps={() => ({
              style: {
                background: "#f0f4f8",
                borderRight: "1px solid #e2e8f0",
                boxShadow: "none",
              },
            })}
            getTrProps={() => ({
              style: {
                borderBottom: "1px solid #f0f0f0",
              },
            })}
            getTdProps={() => ({
              style: {
                borderRight: "1px solid #f5f5f5",
                padding: "10px 8px",
                verticalAlign: "middle",
              },
            })}
          />
        </div>
        <ToastContainer />
        <div
          className="modal fade"
          id="detailInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto", minWidth: "70%", maxWidth: 960 }}
          >
            <div
              className="modal-content"
              style={{ top: 10, margin: "auto", borderRadius: 10, overflow: "hidden", border: "none" }}
            >
              {/* ── HEADER ── */}
              <div
                className="modal-header"
                style={{
                  background: "linear-gradient(135deg, #00254c 0%, #18768f 100%)",
                  padding: "18px 24px",
                  borderBottom: "none",
                }}
              >
                <div>
                  <div style={{ color: "rgba(255,255,255,0.65)", fontSize: 11, letterSpacing: 1, textTransform: "uppercase", marginBottom: 3 }}>
                    Order Details
                  </div>
                  <div
                    className="modal-title"
                    id="exampleModalLabel"
                    style={{ fontWeight: 700, fontSize: 18, color: "white" }}
                  >
                    {productObj && productObj.orderId}
                  </div>
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                  style={{ color: "white", opacity: 0.8, fontSize: 22 }}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              {/* ── BODY ── */}
              <div className="modal-body" style={{ padding: 20, background: "#f4f6f9" }}>

                {/* Warehouse address strip */}
                {productObj && productObj.warehouse && (
                  <div
                    style={{
                      background: "#fff8e1",
                      borderLeft: "4px solid #ffc107",
                      padding: "8px 14px",
                      borderRadius: 4,
                      fontSize: 12,
                      marginBottom: 16,
                      color: "#555",
                    }}
                  >
                    <strong>Warehouse Address:</strong> {productObj.warehouse}
                  </div>
                )}

                {/* ── ITEMS CARD ── */}
                {productObj &&
                  productObj.items &&
                  productObj.items.length > 0 && (
                    <div
                      style={{
                        background: "white",
                        borderRadius: 8,
                        boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                        marginBottom: 16,
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          borderLeft: "4px solid #18768f",
                          padding: "11px 16px",
                          borderBottom: "1px solid #f0f0f0",
                          fontWeight: 700,
                          fontSize: 13,
                          color: "#18768f",
                          background: "#fafafa",
                        }}
                      >
                        Order Items
                      </div>
                      <div style={{ padding: "14px 16px" }}>
                        {productObj.items.map((item, idx) => (
                          <div key={idx} style={{ marginBottom: idx < productObj.items.length - 1 ? 20 : 0 }}>
                            <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 6 }}>{item.name}</div>
                            <div style={{ fontSize: 13, marginBottom: 3 }}>
                              <span style={{ color: "#888" }}>Product Link: </span>
                              <a href={item.detail_url} target="_blank" style={{ color: "#ff8084", wordBreak: "break-all" }}>
                                {item.detail_url}
                              </a>
                            </div>
                            <div style={{ fontSize: 13, marginBottom: 3 }}>
                              <span style={{ color: "#888" }}>Payment Link: </span>
                              <a href={productObj.paymentLink1688} target="_blank" style={{ color: "#ff8084", wordBreak: "break-all" }}>
                                {productObj.paymentLink1688}
                              </a>
                            </div>
                            <div style={{ fontSize: 13, marginBottom: 8 }}>
                              <span style={{ color: "#888" }}>Payment Id: </span>
                              <strong>{productObj.paymentLinkId}</strong>
                            </div>
                            {productObj && productObj.additionalNotes && (
                              <div
                                style={{
                                  background: "#fff3f3",
                                  border: "1px solid #ffd0d0",
                                  borderRadius: 4,
                                  padding: "6px 10px",
                                  fontSize: 13,
                                  marginBottom: 8,
                                }}
                              >
                                <strong>Additional Notes: </strong>
                                <span style={{ color: "red" }}>{productObj.additionalNotes}</span>
                              </div>
                            )}
                            <table
                              className="table table-bordered table-sm"
                              style={{ marginTop: 8, fontSize: 13, background: "white" }}
                            >
                              <thead style={{ background: "#f0f4f8" }}>
                                <tr>
                                  <th style={{ fontWeight: 600 }}>Image</th>
                                  <th style={{ fontWeight: 600 }}>Variant</th>
                                  <th style={{ fontWeight: 600 }}>Price (Tk)</th>
                                  <th style={{ fontWeight: 600 }}>Price (RMB)</th>
                                  <th style={{ fontWeight: 600 }}>Qty</th>
                                  <th style={{ fontWeight: 600 }}>Total RMB</th>
                                </tr>
                              </thead>
                              <tbody>
                                {item.skus.map((sku, i) => (
                                  <tr key={i}>
                                    <td>
                                      <img
                                        style={{
                                          height: 60,
                                          width: 60,
                                          border: "1px solid gainsboro",
                                          borderRadius: 5,
                                          objectFit: "cover",
                                        }}
                                        src={sku.image ? sku.image : item.picture ? item.picture : man}
                                      />
                                    </td>
                                    <td style={{ verticalAlign: "middle" }}>
                                      {sku.color}
                                      {sku.size && <><br />{sku.size}</>}
                                    </td>
                                    <td style={{ verticalAlign: "middle" }}>{sku.price} Tk</td>
                                    <td style={{ verticalAlign: "middle" }}>{parseFloat(sku.priceRMB).toFixed(2)} rmb</td>
                                    <td style={{ verticalAlign: "middle" }}>{sku.totalQuantity} pcs</td>
                                    <td style={{ verticalAlign: "middle", fontWeight: 600 }}>
                                      {parseFloat(sku.priceRMB * sku.totalQuantity).toFixed(2)} rmb
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                {/* ── SUMMARY STAT CARDS ── */}
                <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
                  <div
                    style={{
                      background: "white",
                      borderRadius: 8,
                      padding: "12px 18px",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                      flex: 1,
                      minWidth: 140,
                      borderTop: "3px solid #18768f",
                    }}
                  >
                    <div style={{ color: "#aaa", fontSize: 11, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>
                      Total RMB
                    </div>
                    <div style={{ fontWeight: 700, fontSize: 22, color: "#18768f" }}>
                      {parseFloat(totalRmbAmount).toFixed(2)}{" "}
                      <span style={{ fontSize: 13, fontWeight: 400 }}>Rmb</span>
                    </div>
                  </div>
                  <div
                    style={{
                      background: "white",
                      borderRadius: 8,
                      padding: "12px 18px",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                      flex: 1,
                      minWidth: 140,
                      borderTop: "3px solid #6c757d",
                    }}
                  >
                    <div style={{ color: "#aaa", fontSize: 11, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>
                      Agent
                    </div>
                    <div style={{ fontWeight: 600, fontSize: 15 }}>
                      {productObj &&
                        (this.props.employees.find(
                          (employee) => employee.adminId == productObj.agentId,
                        )?.name || "—")}
                    </div>
                  </div>
                  <div
                    style={{
                      background: "white",
                      borderRadius: 8,
                      padding: "12px 18px",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                      flex: 1,
                      minWidth: 140,
                      borderTop: "3px solid #28a745",
                    }}
                  >
                    <div style={{ color: "#aaa", fontSize: 11, textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 4 }}>
                      Picked Date
                    </div>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>
                      {productObj &&
                        `${productObj.pickedDate ? `${productObj.pickedDate} at ` : ""}${productObj.pickedTime || "—"}`}
                    </div>
                  </div>
                </div>

                {/* ── WAREHOUSE IMAGES ── */}
                <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
                  <div
                    style={{
                      background: "white",
                      borderRadius: 8,
                      padding: "14px 16px",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                      flex: 1,
                    }}
                  >
                    <div style={{ fontWeight: 600, fontSize: 13, color: "#555", marginBottom: 8 }}>
                      BD Warehouse Image
                    </div>
                    <a
                      href={productObj && productObj.imageUrlBd ? productObj.imageUrlBd : ""}
                      target="_blank"
                      onClick={(e) => {
                        if (!productObj?.imageUrlBd) e.preventDefault();
                      }}
                    >
                      <img
                        style={{
                          height: 100,
                          width: 100,
                          border: "1px solid gainsboro",
                          borderRadius: 6,
                          objectFit: "cover",
                        }}
                        src={productObj && productObj.imageUrlBd ? productObj.imageUrlBd : man}
                      />
                    </a>
                  </div>
                  <div
                    style={{
                      background: "white",
                      borderRadius: 8,
                      padding: "14px 16px",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                      flex: 1,
                    }}
                  >
                    <div style={{ fontWeight: 600, fontSize: 13, color: "#555", marginBottom: 8 }}>
                      CN Warehouse Image
                    </div>
                    <a
                      href={productObj && productObj.imageUrl ? productObj.imageUrl : ""}
                      target="_blank"
                      onClick={(e) => {
                        if (!productObj?.imageUrl) e.preventDefault();
                      }}
                    >
                      <img
                        style={{
                          height: 100,
                          width: 100,
                          border: "1px solid gainsboro",
                          borderRadius: 6,
                          objectFit: "cover",
                        }}
                        src={productObj && productObj.imageUrl ? productObj.imageUrl : man}
                      />
                    </a>
                    {productObj && productObj.chineseIssue && (
                      <div style={{ color: "red", fontSize: 12, marginTop: 8 }}>
                        {productObj.chineseIssue}
                      </div>
                    )}
                    {productObj && productObj.returnInfo && (
                      <div style={{ color: "#666", fontSize: 12, marginTop: 8 }}>
                        <strong style={{ color: "#333" }}>Return Info:</strong>
                        <br />
                        {productObj.returnInfo}
                      </div>
                    )}
                  </div>
                </div>

                {/* ── PURCHASING INFO + SHIPPING TIMELINE ── */}
                <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
                  {/* Purchasing Information */}
                  <div
                    style={{
                      background: "white",
                      borderRadius: 8,
                      boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                      flex: 1,
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        borderLeft: "4px solid #18768f",
                        padding: "10px 14px",
                        borderBottom: "1px solid #f0f0f0",
                        fontWeight: 700,
                        fontSize: 13,
                        color: "#18768f",
                        background: "#fafafa",
                      }}
                    >
                      Purchasing Information
                    </div>
                    <div style={{ padding: "10px 14px" }}>
                      {[
                        ["Purchase Link", productObj && productObj.purchaseLink],
                        ["Supplier", productObj && productObj.purchasingSupplier],
                        ["Supplier Payment", productObj && productObj.purchasingSupplierPayment],
                        ["Supplier QR", productObj && productObj.purchasingSupplierQr],
                        [
                          "Purchasing RMB",
                          `${productObj && productObj.purchasingRmb ? productObj.purchasingRmb : 0} rmb`,
                        ],
                        [
                          "Exchange Rate",
                          `${productObj && productObj.exchangeRate ? productObj.exchangeRate : 0} Tk`,
                        ],
                        [
                          "Total Buying Cost",
                          `${
                            productObj && productObj.exchangeRate && productObj.purchasingRmb
                              ? parseInt(productObj.exchangeRate * productObj.purchasingRmb)
                              : 0
                          } Tk`,
                        ],
                        [
                          "Coupon Used",
                          productObj && productObj.couponUsed ? productObj.couponUsed.name : "None",
                        ],
                        [
                          "Product Price",
                          <strong key="pp">{productObj && parseInt(productObj.actualTotal)} Tk</strong>,
                        ],
                      ].map(([label, value], i) => (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "5px 0",
                            borderBottom: "1px solid #f5f5f5",
                            fontSize: 13,
                          }}
                        >
                          <span style={{ color: "#888", minWidth: 140 }}>{label}</span>
                          <span style={{ fontWeight: 500, textAlign: "right", wordBreak: "break-all" }}>{value}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Shipping Timeline */}
                  <div
                    style={{
                      background: "white",
                      borderRadius: 8,
                      boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                      flex: 1,
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        borderLeft: "4px solid #28a745",
                        padding: "10px 14px",
                        borderBottom: "1px solid #f0f0f0",
                        fontWeight: 700,
                        fontSize: 13,
                        color: "#28a745",
                        background: "#fafafa",
                      }}
                    >
                      Shipping Timeline
                    </div>
                    <div style={{ padding: "10px 14px" }}>
                      {[
                        ["Ordered", productObj && productObj.orderedDate],
                        ["Purchased", productObj && productObj["PurchasedDate"]],
                        ["Abroad Warehouse", productObj && productObj["Received in WarehouseDate"]],
                        ["Ready for Fly", productObj && productObj["Ready for flyDate"]],
                        [
                          "Bangladesh Customs",
                          productObj
                            ? productObj["Bangladesh customsDate"]
                              ? productObj["Bangladesh customsDate"]
                              : productObj["Bangladesh warehouseDate"] || ""
                            : "",
                        ],
                        ["Custom Released", productObj && productObj["Bangladesh warehouseDate"]],
                        ["Zapai Warehouse", productObj && productObj["Zapai warehouseDate"]],
                        ["Delivered", productObj && productObj["DeliveredDate"]],
                      ].map(([label, value], i) => (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "5px 0",
                            borderBottom: "1px solid #f5f5f5",
                            fontSize: 13,
                          }}
                        >
                          <span style={{ color: "#888", minWidth: 140 }}>{label}</span>
                          <span style={{ fontWeight: 500, textAlign: "right" }}>{value || "—"}</span>
                        </div>
                      ))}
                      <div style={{ marginTop: 10, paddingTop: 6, borderTop: "1px solid #eee" }}>
                        {[
                          ["Abroad Warehouse Addr.", productObj && productObj.abroadWarehouseAddress],
                          ["BD Warehouse Addr.", productObj && productObj.bangladeshWarehouseAddress],
                          ["Delivered Through", productObj && productObj.deliveredBy],
                        ].map(([label, value], i) => (
                          <div
                            key={i}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "4px 0",
                              borderBottom: "1px solid #f5f5f5",
                              fontSize: 12,
                              color: "#666",
                            }}
                          >
                            <span style={{ minWidth: 140 }}>{label}</span>
                            <span style={{ textAlign: "right" }}>{value || "—"}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* ── SHIPPING INFO + PARCEL INFO ── */}
                <div style={{ display: "flex", gap: 16 }}>
                  {/* Shipping Information */}
                  <div
                    style={{
                      background: "white",
                      borderRadius: 8,
                      boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                      flex: 1,
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        borderLeft: "4px solid #6f42c1",
                        padding: "10px 14px",
                        borderBottom: "1px solid #f0f0f0",
                        fontWeight: 700,
                        fontSize: 13,
                        color: "#6f42c1",
                        background: "#fafafa",
                      }}
                    >
                      Shipping Information
                    </div>
                    <div style={{ padding: "10px 14px" }}>
                      {[
                        ["Carton", productObj && productObj.agentCarton],
                        ["Customer Name", productObj && productObj.displayName],
                        ["Shipping Mark", productObj && productObj.shippingMark ? `${productObj.shippingMark}` : null],
                        ["Tracking No", productObj && productObj.trackingNo],
                        ["Cargo Company", productObj && productObj.cargoCompany],
                        ["Lot Number", productObj && productObj.lotNo ? `${productObj.lotNo}` : null],
                        ["Carton Number", productObj && productObj.ctnNo ? `${productObj.ctnNo}` : null],
                        ["Received Weight", productObj && productObj.receivedWeight ? `${productObj.receivedWeight} kg` : null],
                        ["Cargo Rate", productObj && productObj.cargoRate ? `${productObj.cargoRate} Tk/Kg` : null],
                        ["Customs & Shipping Rate", productObj && productObj.customerRate ? `${productObj.customerRate} Tk/Kg` : null],
                        [
                          "Total Shipping (Cargo)",
                          productObj && productObj.shippingChargeCargo ? `${productObj.shippingChargeCargo} Tk` : null,
                        ],
                        [
                          "Total Shipping (Customer)",
                          productObj && productObj.shippingChargeCustomer
                            ? <strong key="sc">{productObj.shippingChargeCustomer} Tk</strong>
                            : null,
                        ],
                        ["Refund Note", productObj && productObj.refundNote],
                      ].map(([label, value], i) => (
                        <div
                          key={i}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "5px 0",
                            borderBottom: "1px solid #f5f5f5",
                            fontSize: 13,
                          }}
                        >
                          <span style={{ color: "#888", minWidth: 160 }}>{label}</span>
                          <span style={{ fontWeight: 500, textAlign: "right" }}>{value || "—"}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Parcel Info */}
                  <div
                    style={{
                      background: "white",
                      borderRadius: 8,
                      boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                      flex: 1,
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        borderLeft: "4px solid #fd7e14",
                        padding: "10px 14px",
                        borderBottom: "1px solid #f0f0f0",
                        fontWeight: 700,
                        fontSize: 13,
                        color: "#fd7e14",
                        background: "#fafafa",
                      }}
                    >
                      Parcel Info (Cargo Company)
                    </div>
                    <div style={{ padding: "10px 14px" }}>
                      {orderTracking ? (
                        <>
                          {[
                            ["Cargo Company", "ALG LIMITED"],
                            [
                              "Customer",
                              `${orderTracking.userObj.userId} - ${orderTracking.userObj.displayName}`,
                            ],
                            ["Lot No", orderTracking.lotArray.map((lot) => `${lot}`).join(", ")],
                            ["Lot Status", orderTracking.lotObj.shipmentStatus],
                            [
                              "Parcel Status",
                              orderTracking.parcelsArray[0].parcelStatus ||
                                orderTracking.lotObj.shipmentStatus,
                            ],
                            [
                              "Carton No",
                              orderTracking.parcelsArray.map((p) => p.parcelId).join(", "),
                            ],
                            [
                              "Received Date",
                              orderTracking.parcelsArray.map((p) => p.dateofWarehouseReceive).join(", "),
                            ],
                            [
                              "Shipping Mark",
                              orderTracking.parcelsArray.map((p) => p.shippingMark).join(", "),
                            ],
                            [
                              "Product Name",
                              orderTracking.parcelsArray.map((p) => p.productName).join(", "),
                            ],
                            [
                              "Product Contains",
                              orderTracking.parcelsArray.map((p) => p.productType).join(", "),
                            ],
                            [
                              "Total CBM",
                              orderTracking.parcelsArray.map((p) => p.totalCbm).join(", "),
                            ],
                            [
                              "Total Weight",
                              orderTracking.parcelsArray.map((p) => `${p.grossWeight} kg`).join(", "),
                            ],
                            [
                              "Rate/kg",
                              orderTracking.parcelsArray
                                .map((p) => (p.ratePerKg ? `${p.ratePerKg} tk/kg` : "Not given yet"))
                                .join(", "),
                            ],
                            [
                              "Other Charge",
                              orderTracking.parcelsArray
                                .map((p) => (p.otherCharges ? `${p.otherCharges} Tk` : "Not given yet"))
                                .join(", "),
                            ],
                            [
                              "Packaging Cost",
                              orderTracking.parcelsArray
                                .map((p) => (p.packagingCost ? `${p.packagingCost} Tk` : "Not given yet"))
                                .join(", "),
                            ],
                            [
                              "Final Total",
                              orderTracking.parcelsArray
                                .map((p) => (p.finalTotal ? `${p.finalTotal} Tk` : "Not given yet"))
                                .join(", "),
                            ],
                          ].map(([label, value], i) => (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "5px 0",
                                borderBottom: "1px solid #f5f5f5",
                                fontSize: 13,
                              }}
                            >
                              <span style={{ color: "#888", minWidth: 140 }}>{label}</span>
                              <span style={{ fontWeight: 500, textAlign: "right" }}>{value}</span>
                            </div>
                          ))}
                        </>
                      ) : (
                        <div style={{ color: "#aaa", fontSize: 13, padding: "10px 0" }}>
                          No shipping data available.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* ── FOOTER ── */}
              <div
                className="modal-footer"
                style={{ background: "#f4f6f9", borderTop: "1px solid #e0e0e0", padding: "12px 20px" }}
              >
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  style={{ borderRadius: 6, paddingLeft: 20, paddingRight: 20 }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="chineseOrderModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto", minWidth: "60%" }}
          >
            <div className="modal-content" style={{ top: 10, margin: "auto" }}>
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(0, 37, 76)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Order Id: {productObj && productObj.orderId}
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>

              {chineseOrderObj && (
                <div className="modal-body">
                  <div style={{ padding: "0px 15px" }}></div>

                  {productObj &&
                    productObj.items &&
                    productObj.items.length > 0 &&
                    productObj.items.map((item) => (
                      <div>
                        {" "}
                        <div style={{ fontWeight: "bold" }}>
                          {chineseOrderObj.productItems[0].name}
                        </div>
                        <div>
                          Product Link:{" "}
                          <a href={item.detail_url} target="_blank">
                            <span style={{ color: "#ff8084" }}>
                              {item.detail_url}
                            </span>
                          </a>
                        </div>
                        <div>
                          Payment Link:{" "}
                          <a href={productObj.paymentLink1688} target="_blank">
                            <span style={{ color: "#ff8084" }}>
                              {productObj.paymentLink1688}
                            </span>
                          </a>
                        </div>
                        <div style={{ marginBottom: 5, fontWeight: "bold" }}>
                          Payment Id: <span>{productObj.paymentLinkId}</span>
                        </div>
                      </div>
                    ))}
                  {chineseOrderObj && (
                    <div style={{ marginTop: 20 }}>
                      <table className="table table-bordered table-striped table-hover">
                        <tbody>
                          <tr>
                            <th>Product</th>
                            <th>Variation</th>
                            <th>Unit Price</th>
                            <th>Quantity</th>
                            <th>Total</th>
                            <th>Status</th>
                          </tr>
                          {chineseOrderObj.productItems.map((sku) => (
                            <tr>
                              <td>
                                <img
                                  style={{
                                    height: 70,
                                    width: 70,
                                    border: "1px solid gainsboro",
                                    borderRadius: 5,
                                  }}
                                  src={
                                    sku.productImgUrl
                                      ? sku.productImgUrl[0]
                                      : man
                                  }
                                />
                              </td>
                              <td>
                                {sku.skuInfos && sku.skuInfos.length > 0 && (
                                  <div>
                                    {sku.skuInfos.map((sku1) => (
                                      <div
                                        style={{
                                          fontSize: 15,
                                          color: "#555",
                                        }}
                                      >
                                        {sku1.name}:{sku1.value}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </td>
                              <td>
                                ¥{" "}
                                {parseFloat(
                                  sku.itemAmount / sku.quantity,
                                ).toFixed(2)}
                              </td>
                              <td>{sku.quantity}pcs</td>
                              <td>¥ {parseFloat(sku.itemAmount).toFixed(2)}</td>
                              <td>
                                <span
                                  style={{
                                    color: "cadetblue",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {sku.status}
                                </span>
                              </td>
                            </tr>
                          ))}{" "}
                        </tbody>
                      </table>
                    </div>
                  )}

                  <div className="row">
                    <div className="col">
                      <div
                        className="row"
                        style={{
                          fontWeight: "bold",

                          paddingLeft: 20,
                          justifyContent: "flex-start",
                        }}
                      >
                        <span style={{ fontWeight: "lighter" }}>
                          Order Creation Time:
                        </span>{" "}
                        {this.dateFormatter(
                          chineseOrderObj.baseInfo.createTime,
                        )}
                      </div>
                      <div
                        className="row"
                        style={{
                          fontWeight: "bold",
                          marginTop: 5,
                          paddingLeft: 20,
                          justifyContent: "flex-start",
                        }}
                      >
                        <span style={{ fontWeight: "lighter" }}>
                          Order Account:
                        </span>{" "}
                        {chineseOrderObj.baseInfo.buyerLoginId}
                      </div>
                      <div
                        className="row"
                        style={{
                          fontWeight: "bold",
                          marginTop: 5,
                          paddingLeft: 20,
                          justifyContent: "flex-start",
                        }}
                      >
                        <span style={{ fontWeight: "lighter" }}>
                          Order Number (1688):
                        </span>{" "}
                        {chineseOrderObj.baseInfo.idOfStr}
                      </div>
                      <div
                        className="row"
                        style={{
                          fontWeight: "bold",
                          marginTop: 5,
                          paddingLeft: 20,
                          justifyContent: "flex-start",
                        }}
                      >
                        <span style={{ fontWeight: "lighter" }}>
                          Order Total Amount:
                        </span>{" "}
                        ¥ {chineseOrderObj.baseInfo.totalAmount}
                      </div>
                      <div
                        className="row"
                        style={{
                          fontWeight: "bold",
                          marginTop: 5,
                          paddingLeft: 20,
                          justifyContent: "flex-start",
                        }}
                      >
                        <span style={{ fontWeight: "lighter" }}>
                          Shipping Fee:
                        </span>{" "}
                        ¥ {chineseOrderObj.baseInfo.shippingFee}
                      </div>
                      <div
                        className="row"
                        style={{
                          fontWeight: "bold",
                          marginTop: 5,
                          paddingLeft: 20,
                          justifyContent: "flex-start",
                        }}
                      >
                        <span style={{ fontWeight: "lighter" }}>
                          Refund Amount:
                        </span>{" "}
                        ¥ {chineseOrderObj.baseInfo.refund}
                      </div>
                      <div
                        className="row"
                        style={{
                          fontWeight: "bold",
                          marginTop: 5,
                          paddingLeft: 20,
                          justifyContent: "flex-start",
                        }}
                      >
                        <span style={{ fontWeight: "lighter" }}>Status:</span>{" "}
                        <span
                          style={{
                            padding: 2,
                            borderRadius: 3,
                            background: "cadetblue",
                            color: "white",
                            fontWeight: "bold",
                          }}
                        >
                          {chineseOrderObj.baseInfo.status}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className="row"
                    style={{
                      marginBottom: 10,
                      borderTop: "1px solid gainsboro",
                      marginTop: 20,
                      paddingTop: 20,
                    }}
                  >
                    <div className="col">
                      <div
                        style={{
                          paddingLeft: 7,
                          color: "#18768f",
                          fontWeight: "bold",
                          marginBottom: 5,
                        }}
                      >
                        Seller Information
                      </div>

                      <div className="category-list-shipping">
                        Company Name:{" "}
                        <span
                          style={{
                            fontWeight: "lighter",
                            textTransform: "capitalize",
                          }}
                        >
                          {chineseOrderObj.baseInfo.sellerContact.companyName}
                        </span>
                      </div>
                      <div className="category-list-shipping">
                        Email:{" "}
                        <span
                          style={{
                            fontWeight: "lighter",
                            textTransform: "capitalize",
                          }}
                        >
                          {chineseOrderObj.baseInfo.sellerContact.email}
                        </span>
                      </div>
                      <div className="category-list-shipping">
                        Mobile:{" "}
                        <span
                          style={{
                            fontWeight: "lighter",
                            textTransform: "capitalize",
                          }}
                        >
                          {chineseOrderObj.baseInfo.sellerContact.mobile}
                        </span>
                      </div>
                      <div className="category-list-shipping">
                        Name:{" "}
                        <span
                          style={{
                            fontWeight: "lighter",
                            textTransform: "capitalize",
                          }}
                        >
                          {chineseOrderObj.baseInfo.sellerContact.name}
                        </span>
                      </div>
                      <div className="category-list-shipping">
                        Phone:
                        <span
                          style={{
                            fontWeight: "lighter",
                            textTransform: "capitalize",
                          }}
                        >
                          {chineseOrderObj.baseInfo.sellerContact.phone}
                        </span>
                      </div>
                      <div className="category-list-shipping">
                        Shop Name:{" "}
                        <span
                          style={{
                            fontWeight: "lighter",
                            textTransform: "capitalize",
                          }}
                        >
                          {chineseOrderObj.baseInfo.sellerContact.shopName}
                        </span>
                      </div>
                    </div>
                    <div className="col">
                      <div
                        style={{
                          paddingLeft: 7,
                          color: "#18768f",
                          fontWeight: "bold",
                          marginBottom: 5,
                        }}
                      >
                        Receiver Information
                      </div>
                      <div className="category-list-shipping">
                        Name:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {chineseOrderObj.nativeLogistics.contactPerson}
                        </span>
                      </div>
                      <div className="category-list-shipping">
                        Mobile:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {chineseOrderObj.nativeLogistics.mobile}
                        </span>
                      </div>
                      <div className="category-list-shipping">
                        Postcode:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {chineseOrderObj.nativeLogistics.zip}
                        </span>
                      </div>
                      <div className="category-list-shipping">
                        Province:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {chineseOrderObj.nativeLogistics.province}
                        </span>
                      </div>
                      <div className="category-list-shipping">
                        City:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {chineseOrderObj.nativeLogistics.city}
                        </span>
                      </div>
                      <div className="category-list-shipping">
                        Address:{" "}
                        <span style={{ fontWeight: "lighter" }}>
                          {chineseOrderObj.nativeLogistics.address}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="pickModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="pickModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "30px auto", minWidth: "65%", maxWidth: 820 }}
          >
            <div className="modal-content" style={{ borderRadius: 14, overflow: "hidden", border: "none", boxShadow: "0 20px 60px rgba(0,0,0,0.18)" }}>

              {/* ── HEADER ── */}
              <div style={{
                background: "linear-gradient(135deg, #00254c 0%, #18768f 100%)",
                padding: "18px 24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
                <div>
                  <div style={{ color: "rgba(255,255,255,0.55)", fontSize: 10, letterSpacing: 1.2, textTransform: "uppercase", marginBottom: 3 }}>
                    Pick Order · 1688.com
                  </div>
                  <div id="pickModalLabel" style={{ fontWeight: 700, fontSize: 16, color: "white", letterSpacing: 0.3 }}>
                    Order: {productObj && productObj.orderId}
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                  <div style={{ textAlign: "right" }}>
                    <div style={{ color: "rgba(255,255,255,0.55)", fontSize: 10, letterSpacing: 0.8, textTransform: "uppercase" }}>Total Cost</div>
                    <div style={{ color: "white", fontWeight: 700, fontSize: 18 }}>
                      ¥{parseFloat(totalRmbAmount).toFixed(2)} <span style={{ fontSize: 11, fontWeight: 400, opacity: 0.65 }}>RMB</span>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    style={{ color: "rgba(255,255,255,0.75)", fontSize: 24, lineHeight: 1, background: "none", border: "none", cursor: "pointer", marginLeft: 8 }}
                  >
                    &times;
                  </button>
                </div>
              </div>

              {/* ── BODY ── */}
              <div style={{ background: "#f4f6f9", padding: "20px 22px", maxHeight: "68vh", overflowY: "auto" }}>

                {/* Warehouse note */}
                {productObj?.warehouse && (
                  <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 8, padding: "8px 14px", marginBottom: 14, fontSize: 12, color: "#78350f", display: "flex", gap: 8, alignItems: "center" }}>
                    <span style={{ fontSize: 14 }}>📦</span>
                    <span><strong>Warehouse:</strong> {productObj.warehouse}</span>
                  </div>
                )}

                {/* Order Items */}
                {productObj?.items?.map((item, itemIdx) => (
                  <div key={itemIdx} style={{ background: "white", borderRadius: 10, padding: "16px 18px", marginBottom: 14, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>

                    {/* Item header */}
                    <div style={{ marginBottom: 12, paddingBottom: 10, borderBottom: "1px solid #f0f0f0" }}>
                      <div style={{ fontWeight: 700, fontSize: 13, color: "#00254c", marginBottom: 5, lineHeight: 1.4 }}>
                        {item.name}
                      </div>
                      <a
                        href={item.detail_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: 11, color: "#18768f", textDecoration: "none", wordBreak: "break-all", display: "block" }}
                      >
                        🔗 {item.detail_url}
                      </a>
                      {productObj?.additionalNotes && (
                        <div style={{ marginTop: 8, fontSize: 11, color: "#b91c1c", background: "#fff5f5", padding: "5px 10px", borderRadius: 6, borderLeft: "3px solid #ef4444" }}>
                          <strong>Note:</strong> {productObj.additionalNotes}
                        </div>
                      )}
                    </div>

                    {/* SKU rows */}
                    {item.skus.map((sku, skuIdx) => (
                      <div
                        key={skuIdx}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 14,
                          padding: "10px 0",
                          borderBottom: skuIdx < item.skus.length - 1 ? "1px solid #f5f5f5" : "none",
                        }}
                      >
                        <img
                          src={sku.image || item.picture || man}
                          alt=""
                          style={{ width: 58, height: 58, objectFit: "cover", borderRadius: 8, border: "1px solid #eee", flexShrink: 0 }}
                        />
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 5 }}>
                            {sku.color && (
                              <span style={{ fontSize: 11, background: "#e0f2fe", color: "#0369a1", padding: "2px 9px", borderRadius: 12, fontWeight: 500 }}>
                                {sku.color}
                              </span>
                            )}
                            {sku.size && (
                              <span style={{ fontSize: 11, background: "#dcfce7", color: "#166534", padding: "2px 9px", borderRadius: 12, fontWeight: 500 }}>
                                {sku.size}
                              </span>
                            )}
                            {!sku.color && !sku.size && (
                              <span style={{ fontSize: 11, color: "#aaa" }}>No variant</span>
                            )}
                          </div>
                          <div style={{ fontSize: 11, color: "#888" }}>
                            {sku.price} Tk &nbsp;·&nbsp; ¥{parseFloat(sku.priceRMB).toFixed(2)} RMB each
                          </div>
                        </div>
                        <div style={{ textAlign: "right", flexShrink: 0 }}>
                          <div style={{ fontSize: 11, color: "#999", marginBottom: 3 }}>
                            {sku.totalQuantity} pcs
                          </div>
                          <div style={{ fontWeight: 700, fontSize: 14, color: "#00254c" }}>
                            ¥{parseFloat(sku.priceRMB * sku.totalQuantity).toFixed(2)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}

                {/* Carton type */}
                <div style={{ background: "white", borderRadius: 10, padding: "16px 18px", marginBottom: 14, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                  <div style={{ fontSize: 10, color: "#18768f", textTransform: "uppercase", letterSpacing: 1, fontWeight: 700, marginBottom: 12, display: "flex", alignItems: "center", gap: 6 }}>
                    <div style={{ width: 3, height: 13, background: "#18768f", borderRadius: 2 }} />
                    Carton Type
                  </div>
                  <select
                    name="agentCarton"
                    className="form-control"
                    onChange={this.handleChange}
                    value={this.state.agentCarton}
                    required
                    style={{ fontSize: 13, borderRadius: 7, border: "1px solid #dde1e7", padding: "9px 12px", background: "#fafbfc" }}
                  >
                    <option value="">— Select Carton Type —</option>
                    <option value="Shoes">Shoes</option>
                    <option value="Clothing">Clothing</option>
                    <option value="Bag">Bag</option>
                    <option value="Cosmetics">Cosmetics</option>
                    <option value="Jewelry">Jewelry</option>
                    <option value="Machinary + Parts">Machinery + Parts</option>
                    <option value="Battery Item">Battery Item</option>
                    <option value="China Mix">China Mix</option>
                    <option value="Hongkong Mix">Hongkong Mix</option>
                  </select>
                </div>

                {/* Shipping address */}
                <div style={{ background: "white", borderRadius: 10, padding: "16px 18px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                  <div style={{ fontSize: 10, color: "#18768f", textTransform: "uppercase", letterSpacing: 1, fontWeight: 700, marginBottom: 14, display: "flex", alignItems: "center", gap: 6 }}>
                    <div style={{ width: 3, height: 13, background: "#18768f", borderRadius: 2 }} />
                    China Shipping Address
                  </div>
                  {shippingAddress && shippingAddress.length > 0 ? (
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                      {shippingAddress.map((address) => {
                        const isSelected = this.state.selectedAddress?.id === address.id;
                        return (
                          <div
                            key={address.id}
                            onClick={() => this.setState({ selectedAddress: address })}
                            style={{
                              padding: "13px 15px",
                              borderRadius: 10,
                              border: isSelected ? "2px solid #18768f" : "2px solid #eee",
                              background: isSelected ? "#f0f9ff" : "white",
                              cursor: "pointer",
                              transition: "border-color 0.15s, background 0.15s",
                              position: "relative",
                            }}
                          >
                            {isSelected && (
                              <div style={{
                                position: "absolute", top: 8, right: 8,
                                background: "#18768f", color: "white",
                                borderRadius: 20, padding: "2px 9px",
                                fontSize: 10, fontWeight: 700, letterSpacing: 0.3,
                              }}>
                                ✓ Selected
                              </div>
                            )}
                            <div style={{ fontWeight: 700, fontSize: 12, color: isSelected ? "#18768f" : "#222", marginBottom: 5, paddingRight: isSelected ? 60 : 0 }}>
                              {address.fullName}
                            </div>
                            <div style={{ fontSize: 11, color: "#555", marginBottom: 2 }}>{address.mobilePhone}</div>
                            <div style={{ fontSize: 11, color: "#666", marginBottom: 2, lineHeight: 1.4 }}>{address.address}</div>
                            {(address.addressCode || address.post) && (
                              <div style={{ fontSize: 10, color: "#aaa", marginTop: 4 }}>
                                {address.addressCode && `Code: ${address.addressCode}`}
                                {address.addressCode && address.post && "  ·  "}
                                {address.post && `Post: ${address.post}`}
                              </div>
                            )}
                            <div style={{ fontSize: 10, color: "#ccc", marginTop: 3 }}>ID: {address.id}</div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div style={{ textAlign: "center", padding: "24px", color: "#aaa", fontSize: 13 }}>
                      No shipping addresses available
                    </div>
                  )}
                </div>
              </div>

              {/* ── FOOTER ── */}
              <div style={{ background: "white", padding: "14px 22px", borderTop: "1px solid #eee", display: "flex", justifyContent: "flex-end", gap: 10 }}>
                <button
                  type="button"
                  className="btn"
                  data-dismiss="modal"
                  disabled={this.state.pickLoading}
                  style={{ fontSize: 13, borderRadius: 7, border: "1px solid #dde1e7", color: "#555", background: "white", padding: "9px 20px" }}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn"
                  disabled={this.state.pickLoading}
                  style={{
                    fontSize: 13,
                    borderRadius: 7,
                    background: this.state.pickLoading
                      ? "#94a3b8"
                      : "linear-gradient(135deg, #00254c, #18768f)",
                    color: "white",
                    padding: "9px 28px",
                    fontWeight: 600,
                    minWidth: 150,
                    cursor: this.state.pickLoading ? "not-allowed" : "pointer",
                  }}
                  onClick={async () => {
                    if (!this.state.agentCarton) {
                      notifyWarning(
                        "Please choose a carton. You can't pick an order without choosing a carton",
                      );
                      return;
                    }
                    if (!this.state.selectedAddress?.id) {
                      notifyWarning(
                        "Please choose a shipping address. You can't pick an order without choosing a shipping address",
                      );
                      return;
                    }
                    if (!this.props.currentAdmin?.adminId) return;

                    this.setState({ pickLoading: true });
                    try {
                      const date = new Date();
                      const orderObj1688 = await create1688Order(
                        productObj,
                        this.state.selectedAddress.id,
                      );
                      await this.props.updateOrderApiRedux({
                        ...productObj,
                        agentStatus: "Picked",
                        agentId: this.props.currentAdmin.adminId,
                        pickedDate: date.toLocaleDateString("en-GB"),
                        pickedTime: date.toLocaleTimeString("en-GB"),
                        totalRmbAmount: parseFloat(totalRmbAmount).toFixed(2),
                        agentCarton: this.state.agentCarton,
                        orderNumber: orderObj1688?.orderId || "",
                        creationTime1688: {
                          postFee: orderObj1688?.postFee
                            ? parseFloat(orderObj1688.postFee / 100).toFixed(2)
                            : "",
                          totalSuccessAmount: orderObj1688?.totalSuccessAmount
                            ? parseFloat(orderObj1688.totalSuccessAmount / 100).toFixed(2)
                            : "",
                        },
                        chinaAddress: this.state.selectedAddress,
                      });
                      window.$("#pickModal").modal("hide");
                    } finally {
                      this.setState({ pickLoading: false });
                    }
                  }}
                >
                  {this.state.pickLoading ? (
                    <span>
                      <span className="spinner-border spinner-border-sm" role="status" style={{ marginRight: 8, width: 13, height: 13, borderWidth: 2 }} />
                      Placing on 1688…
                    </span>
                  ) : (
                    "Confirm Pick"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="paymentModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="paymentModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "30px auto", minWidth: "62%", maxWidth: 780 }}
          >
            <div className="modal-content" style={{ borderRadius: 14, overflow: "hidden", border: "none", boxShadow: "0 20px 60px rgba(0,0,0,0.18)" }}>

              {/* ── HEADER ── */}
              <div style={{
                background: "linear-gradient(135deg, #00254c 0%, #18768f 100%)",
                padding: "18px 24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
                <div>
                  <div style={{ color: "rgba(255,255,255,0.55)", fontSize: 10, letterSpacing: 1.2, textTransform: "uppercase", marginBottom: 3 }}>
                    Payment Management
                  </div>
                  <div id="paymentModalLabel" style={{ fontWeight: 700, fontSize: 16, color: "white", letterSpacing: 0.3 }}>
                    Order: {productObj && productObj.orderId}
                  </div>
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                  style={{ color: "rgba(255,255,255,0.75)", fontSize: 22, lineHeight: 1, background: "none", border: "none", cursor: "pointer" }}
                >
                  &times;
                </button>
              </div>

              {/* ── SUMMARY CARDS ── */}
              <div style={{ display: "flex", borderBottom: "1px solid #e8ecf0" }}>
                {[
                  {
                    label: "Total Payable",
                    value: totalPayableAmountIncludingShipping || 0,
                    color: "#00254c",
                    bg: "#ffffff",
                    accent: "#00254c",
                  },
                  {
                    label: "Total Paid",
                    value: totalPaid,
                    color: "#0369a1",
                    bg: "#f0f9ff",
                    accent: "#0ea5e9",
                  },
                  {
                    label: "Total Due",
                    value: Math.max(0, (totalPayableAmountIncludingShipping || 0) - totalPaid),
                    color: (totalPayableAmountIncludingShipping || 0) - totalPaid > 0 ? "#b91c1c" : "#15803d",
                    bg: (totalPayableAmountIncludingShipping || 0) - totalPaid > 0 ? "#fff5f5" : "#f0fdf4",
                    accent: (totalPayableAmountIncludingShipping || 0) - totalPaid > 0 ? "#ef4444" : "#22c55e",
                  },
                ].map(({ label, value, color, bg, accent }, idx) => (
                  <div key={label} style={{
                    flex: 1,
                    padding: "14px 20px",
                    background: bg,
                    borderRight: idx < 2 ? "1px solid #e8ecf0" : "none",
                    textAlign: "center",
                    borderTop: `3px solid ${accent}`,
                  }}>
                    <div style={{ fontSize: 10, color: "#999", textTransform: "uppercase", letterSpacing: 0.8, marginBottom: 5, fontWeight: 600 }}>
                      {label}
                    </div>
                    <div style={{ fontWeight: 700, fontSize: 20, color, letterSpacing: 0.5 }}>
                      {value} <span style={{ fontSize: 13, fontWeight: 500 }}>Tk</span>
                    </div>
                  </div>
                ))}
              </div>

              {/* ── BODY ── */}
              <div style={{ background: "#f4f6f9", padding: "20px 22px", maxHeight: "65vh", overflowY: "auto" }}>

                {/* Price Breakdown */}
                <div style={{ background: "white", borderRadius: 10, padding: "16px 18px", marginBottom: 14, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                  <div style={{ fontSize: 10, color: "#18768f", textTransform: "uppercase", letterSpacing: 1, fontWeight: 700, marginBottom: 12, display: "flex", alignItems: "center", gap: 6 }}>
                    <div style={{ width: 3, height: 13, background: "#18768f", borderRadius: 2 }} />
                    Price Breakdown
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2px 32px" }}>
                    {[
                      { label: "Product Price", value: `${productObj?.actualTotal || 0} Tk`, highlight: false },
                      { label: "Coupon Used", value: productObj?.couponUsed ? productObj.couponUsed.name : "—", highlight: false },
                      { label: "Coupon Discount", value: `-${productObj?.couponAmount || 0} Tk`, highlight: false },
                      {
                        label: "Offer Discount",
                        value: `-${productObj?.offer && productObj.offer !== 0
                          ? Math.round((productObj.actualTotalAfterCoupon || 0) * (parseFloat(productObj.offer) / 100))
                          : 0} Tk`,
                        highlight: false,
                      },
                      { label: "Price After Discount", value: `${priceAfterDiscount || 0} Tk`, highlight: true },
                      { label: "Local Delivery", value: `+${productObj?.deliveryCharge || 0} Tk`, highlight: false },
                      { label: "China Shipping (local)", value: `+${productObj?.localShipping || 0} Tk`, highlight: false },
                      { label: "Packaging & Other", value: `+${productObj?.otherCost || 0} Tk`, highlight: false },
                      { label: "Shipment Discount", value: `-${productObj?.discount || 0} Tk`, highlight: false },
                      { label: "Intl. Shipping Charge", value: `+${productObj?.shippingChargeCustomer || 0} Tk`, highlight: false },
                    ].map(({ label, value, highlight }) => (
                      <div key={label} style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "5px 0",
                        borderBottom: "1px solid #f5f5f5",
                      }}>
                        <span style={{ fontSize: 12, color: highlight ? "#00254c" : "#777", fontWeight: highlight ? 600 : 400 }}>
                          {label}
                        </span>
                        <span style={{ fontSize: 12, color: highlight ? "#00254c" : "#333", fontWeight: highlight ? 700 : 500 }}>
                          {value}
                        </span>
                      </div>
                    ))}
                  </div>
                  {/* Refunded */}
                  {productObj?.refund ? (
                    <div style={{ marginTop: 8, paddingTop: 8, borderTop: "1px dashed #e0e0e0", display: "flex", justifyContent: "space-between" }}>
                      <span style={{ fontSize: 12, color: "#777" }}>Refunded</span>
                      <span style={{ fontSize: 12, fontWeight: 600, color: "#b91c1c" }}>{productObj.refund} Tk</span>
                    </div>
                  ) : null}
                </div>

                {/* Status pills */}
                <div style={{ display: "flex", gap: 12, marginBottom: 14 }}>
                  {/* Payment Status */}
                  <div style={{ flex: 1, background: "white", borderRadius: 10, padding: "12px 16px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span style={{ fontSize: 11, color: "#888", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>Payment</span>
                    <span style={{
                      fontSize: 11, fontWeight: 700, padding: "4px 10px", borderRadius: 20, color: "white",
                      background: (() => {
                        const s = getPaymentStatusStr(productObj?.paymentStatus);
                        return s === "Paid" ? "#15803d" : s === "Partially Paid" ? "#d97706" : s === "purchaseLater" ? "#6b7280" : "#dc2626";
                      })(),
                    }}>
                      {getPaymentStatusStr(productObj?.paymentStatus)}
                    </span>
                  </div>
                  {/* Order Status */}
                  <div style={{ flex: 1, background: "white", borderRadius: 10, padding: "12px 16px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span style={{ fontSize: 11, color: "#888", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>Order</span>
                    <span style={{
                      fontSize: 11, fontWeight: 700, padding: "4px 10px", borderRadius: 20, color: "white",
                      background: (() => {
                        const s = productObj?.orderStatus;
                        if (!s || s === "pending" || s === "order_pending") return "#6b7280";
                        if (s === "Purchased") return "#64748b";
                        if (s === "Received in Warehouse") return "#d97706";
                        if (s === "Ready for fly") return "#ea580c";
                        if (s === "Bangladesh customs") return "#92400e";
                        if (s === "Bangladesh warehouse") return "#0891b2";
                        if (s === "Zapai warehouse") return "#15803d";
                        if (s === "Delivered") return "#166534";
                        return "#dc2626";
                      })(),
                    }}>
                      {productObj?.orderStatus === "order_pending" ? "pending" : (productObj?.orderStatus || "—")}
                    </span>
                  </div>
                  {/* Shipping weight */}
                  <div style={{ flex: 1, background: "white", borderRadius: 10, padding: "12px 16px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <span style={{ fontSize: 11, color: "#888", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5 }}>Weight</span>
                    <span style={{ fontSize: 13, fontWeight: 700, color: "#00254c" }}>
                      {productObj?.receivedWeight || "—"} <span style={{ fontWeight: 400, fontSize: 11, color: "#888" }}>kg</span>
                    </span>
                  </div>
                </div>

                {/* New Payment Form */}
                <div style={{ background: "white", borderRadius: 10, padding: "16px 18px", marginBottom: 14, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                  <div style={{ fontSize: 10, color: "#18768f", textTransform: "uppercase", letterSpacing: 1, fontWeight: 700, marginBottom: 14, display: "flex", alignItems: "center", gap: 6 }}>
                    <div style={{ width: 3, height: 13, background: "#18768f", borderRadius: 2 }} />
                    Record New Payment
                  </div>
                  <form onSubmit={(e) => this.handleSubmit(e, totalPayableAmountIncludingShipping - totalPaid)}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 14 }}>
                      <div>
                        <label style={{ fontSize: 11, fontWeight: 600, color: "#555", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 5, display: "block" }}>
                          Payment Method
                        </label>
                        <select
                          name="method"
                          className="form-control"
                          onChange={this.handleChange}
                          value={this.state.method}
                          required
                          style={{ fontSize: 13, borderRadius: 7, border: "1px solid #dde1e7", padding: "8px 10px", background: "#fafbfc" }}
                        >
                          <option value="">Select Method</option>
                          <option value="Cash">Cash</option>
                          <option value="Bkash">bKash</option>
                          <option value="Nagad">Nagad</option>
                          <option value="Rocket">Rocket</option>
                          <option value="City">City Bank</option>
                          <option value="UCB Bank">UCB Bank</option>
                          <option value="BRAC Bank">BRAC Bank</option>
                        </select>
                      </div>
                      <div>
                        <label style={{ fontSize: 11, fontWeight: 600, color: "#555", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 5, display: "block" }}>
                          Amount (Tk)
                        </label>
                        <input
                          type="number"
                          name="amount"
                          className="form-control"
                          placeholder="0"
                          onChange={this.handleChange}
                          value={this.state.amount}
                          required
                          style={{ fontSize: 13, borderRadius: 7, border: "1px solid #dde1e7", padding: "8px 10px", background: "#fafbfc" }}
                        />
                      </div>
                      <div>
                        <label style={{ fontSize: 11, fontWeight: 600, color: "#555", textTransform: "uppercase", letterSpacing: 0.5, marginBottom: 5, display: "block" }}>
                          Payment Status
                        </label>
                        <select
                          name="paymentStatus"
                          className="form-control"
                          onChange={this.handleChange}
                          value={this.state.paymentStatus}
                          required
                          style={{ fontSize: 13, borderRadius: 7, border: "1px solid #dde1e7", padding: "8px 10px", background: "#fafbfc" }}
                        >
                          <option value="">Select Status</option>
                          <option value="Partially Paid">Partially Paid</option>
                          <option value="Paid">Fully Paid</option>
                        </select>
                      </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                      <button
                        type="button"
                        className="btn"
                        data-dismiss="modal"
                        id="close-button-for-payment-modal"
                        style={{ fontSize: 13, borderRadius: 7, border: "1px solid #dde1e7", color: "#555", background: "white", padding: "8px 20px" }}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn"
                        style={{ fontSize: 13, borderRadius: 7, background: "linear-gradient(135deg, #00254c, #18768f)", color: "white", padding: "8px 24px", fontWeight: 600 }}
                      >
                        Save Payment
                      </button>
                    </div>
                  </form>
                </div>

                {/* Previous Payments */}
                {this.state.productObj?.payments?.length > 0 && (
                  <div style={{ background: "white", borderRadius: 10, padding: "16px 18px", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                    <div style={{ fontSize: 10, color: "#18768f", textTransform: "uppercase", letterSpacing: 1, fontWeight: 700, marginBottom: 12, display: "flex", alignItems: "center", gap: 6 }}>
                      <div style={{ width: 3, height: 13, background: "#18768f", borderRadius: 2 }} />
                      Payment History
                    </div>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                      <thead>
                        <tr style={{ background: "#f4f6f9" }}>
                          {["Date", "Method", "Amount", "Received By"].map((h) => (
                            <th key={h} style={{ padding: "8px 12px", textAlign: "left", fontSize: 10, color: "#888", fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, borderBottom: "1px solid #eee" }}>
                              {h}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.productObj.payments.map((payment, idx) => (
                          <tr key={idx} style={{ borderBottom: "1px solid #f5f5f5" }}>
                            <td style={{ padding: "9px 12px", color: "#555" }}>{payment.date}</td>
                            <td style={{ padding: "9px 12px" }}>
                              <span style={{ background: "#e8f4fd", color: "#0369a1", fontSize: 11, fontWeight: 600, padding: "2px 8px", borderRadius: 10 }}>
                                {payment.method}
                              </span>
                            </td>
                            <td style={{ padding: "9px 12px", fontWeight: 700, color: "#00254c" }}>{payment.amount} Tk</td>
                            <td style={{ padding: "9px 12px", color: "#555" }}>{payment.receivedBy}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="trackingModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto", minWidth: "60%" }}
          >
            <div className="modal-content" style={{ top: 10, margin: "auto" }}>
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(0, 37, 76)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Tracking No: {productObj && productObj.trackingNo}
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              {chineseTrackingObj && (
                <div className="modal-body">
                  <div className="row">
                    <div
                      className="col"
                      style={{
                        fontWeight: "bold",
                        borderBottom: "1px solid gainsboro",
                        paddingBottom: 5,
                      }}
                    >
                      Order Id (1688): {productObj && productObj.orderNumber}
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: 10,
                      padding: 40,
                      paddingBottom: 0,
                      paddingTop: 20,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "30px 0",
                      }}
                    >
                      {/* Step 1 */}
                      <div
                        style={{
                          textAlign: "center",
                          color: "#fff",
                        }}
                      >
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            fontSize: "26px",
                            backgroundColor:
                              productObj.chineseShipmentStatusScore == 1
                                ? "white"
                                : productObj.chineseShipmentStatusScore > 1
                                  ? "#f9c9a9"
                                  : "#eee",
                            border:
                              productObj.chineseShipmentStatusScore == 1
                                ? "3px solid #f60"
                                : "none",
                          }}
                        >
                          🏭
                        </div>
                        <div
                          style={{
                            color:
                              productObj.chineseShipmentStatusScore >= 1
                                ? "#f60"
                                : "#bbb",
                            marginTop: "8px",
                          }}
                        >
                          Consigned
                        </div>
                      </div>

                      {/* Dotted line */}
                      <div
                        style={{
                          flex: 1,
                          borderTop:
                            productObj.chineseShipmentStatusScore > 1
                              ? "2px dashed #f6c8a5"
                              : "2px dashed #ddd",
                          margin: "0 10px",
                        }}
                      ></div>

                      {/* Step 2 */}
                      <div
                        style={{
                          textAlign: "center",
                          color: "#fff",
                        }}
                      >
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            borderRadius: "50%",

                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            fontSize: "26px",
                            backgroundColor:
                              productObj.chineseShipmentStatusScore == 2
                                ? "white"
                                : productObj.chineseShipmentStatusScore > 2
                                  ? "#f9c9a9"
                                  : "#eee",
                            border:
                              productObj.chineseShipmentStatusScore == 2
                                ? "3px solid #f60"
                                : "none",
                          }}
                        >
                          📦
                        </div>
                        <div
                          style={{
                            color:
                              productObj.chineseShipmentStatusScore >= 2
                                ? "#f60"
                                : "#bbb",
                            marginTop: "8px",
                          }}
                        >
                          Shipped
                        </div>
                      </div>

                      {/* Dotted line */}
                      <div
                        style={{
                          flex: 1,
                          borderTop:
                            productObj.chineseShipmentStatusScore > 2
                              ? "2px dashed #f6c8a5"
                              : "2px dashed #ddd",
                          margin: "0 10px",
                        }}
                      ></div>

                      {/* Step 3 (active) */}
                      <div
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            borderRadius: "50%",

                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            fontSize: "26px",
                            color: "#f60",
                            backgroundColor:
                              productObj.chineseShipmentStatusScore == 3
                                ? "white"
                                : productObj.chineseShipmentStatusScore > 3
                                  ? "#f9c9a9"
                                  : "#eee",
                            border:
                              productObj.chineseShipmentStatusScore == 3
                                ? "3px solid #f60"
                                : "none",
                          }}
                        >
                          🚚
                        </div>
                        <div
                          style={{
                            color:
                              productObj.chineseShipmentStatusScore >= 3
                                ? "#f60"
                                : "#bbb",
                            marginTop: "8px",
                          }}
                        >
                          In Transit
                        </div>
                      </div>

                      {/* Dotted line */}
                      <div
                        style={{
                          flex: 1,
                          borderTop:
                            productObj.chineseShipmentStatusScore > 3
                              ? "2px dashed #f6c8a5"
                              : "2px dashed #ddd",
                          margin: "0 10px",
                        }}
                      ></div>

                      {/* Step 4 */}
                      <div
                        style={{
                          textAlign: "center",
                          color: "#bbb",
                        }}
                      >
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            borderRadius: "50%",

                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            fontSize: "26px",
                            backgroundColor:
                              productObj.chineseShipmentStatusScore == 4
                                ? "white"
                                : productObj.chineseShipmentStatusScore > 4
                                  ? "#f9c9a9"
                                  : "#eee",
                            border:
                              productObj.chineseShipmentStatusScore == 4
                                ? "3px solid #f60"
                                : "none",
                          }}
                        >
                          🕵
                        </div>
                        <div
                          style={{
                            color:
                              productObj.chineseShipmentStatusScore >= 4
                                ? "#f60"
                                : "#bbb",
                            marginTop: "8px",
                          }}
                        >
                          Delivering
                        </div>
                      </div>

                      {/* Dotted line */}
                      <div
                        style={{
                          flex: 1,
                          borderTop:
                            productObj.chineseShipmentStatusScore > 4
                              ? "2px dashed #f6c8a5"
                              : "2px dashed #ddd",
                          margin: "0 10px",
                        }}
                      ></div>

                      {/* Step 5 */}
                      <div
                        style={{
                          textAlign: "center",
                          color: "#bbb",
                        }}
                      >
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            borderRadius: "50%",

                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            fontSize: "26px",
                            backgroundColor:
                              productObj.chineseShipmentStatusScore == 5
                                ? "#f9c9a9"
                                : productObj.chineseShipmentStatusScore > 5
                                  ? "#f9c9a9"
                                  : "#eee",
                            border:
                              productObj.chineseShipmentStatusScore == 5
                                ? "3px solid #f60"
                                : "none",
                          }}
                        >
                          ✅
                        </div>
                        <div
                          style={{
                            color:
                              productObj.chineseShipmentStatusScore >= 5
                                ? "#f60"
                                : "#bbb",
                            marginTop: "8px",
                          }}
                        >
                          Delivered
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ margin: 20 }}>
                    <div
                      style={{
                        background: "#f6f6f6ff",
                        borderRadius: 5,
                        padding: 15,
                      }}
                    >
                      {this.getTracing(chineseTrackingObj.logisticsSteps)}
                    </div>
                  </div>
                </div>
              )}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  id="close-button-for-payment-modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="deleteModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto", minWidth: "60%" }}
          >
            <div className="modal-content" style={{ top: 10, margin: "auto" }}>
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(0, 37, 76)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Booking Id: {productObj && productObj.orderId}
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div
                    className="col"
                    style={{
                      fontWeight: "bold",

                      paddingBottom: 5,
                    }}
                  >
                    Are you sure you want to delete this order?
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn "
                  style={{ backgroundColor: "red", color: "white" }}
                  data-dismiss="modal"
                  onClick={() => {
                    this.props.deleteOrderApiRedux(productObj);
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="request_payment"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto", minWidth: "60%" }}
          >
            <div className="modal-content" style={{ top: 10, margin: "auto" }}>
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(0, 37, 76)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Request for Payment
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              {this.state.orders && this.state.orders.length > 0 && (
                <div className="modal-body">
                  <div className="row" style={{ padding: 20 }}>
                    <table className="table table-bordered table-striped table-hover">
                      <thead style={{ background: "#18768f", color: "white" }}>
                        <tr>
                          <td style={{ fontWeight: "bold" }}>Product</td>
                          <td style={{ fontWeight: "bold" }}>Name</td>
                          <td style={{ fontWeight: "bold" }}>Order Number</td>

                          <td style={{ fontWeight: "bold" }}>Total</td>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.orders.map((order) => (
                          <tr>
                            <td>
                              <img
                                src={
                                  order.items && order.items[0]
                                    ? order.items[0].picture
                                    : ""
                                }
                                style={{
                                  height: 70,
                                  width: 70,
                                  borderRadius: 5,
                                }}
                              />
                            </td>
                            <td>
                              {order.items && order.items[0]
                                ? order.items[0].name.slice(0, 100)
                                : ""}
                            </td>
                            <td>{order.orderNumber}</td>
                            <td>
                              <div>
                                ¥
                                {order.creationTime1688
                                  ? order.creationTime1688.totalSuccessAmount
                                  : 0}
                              </div>
                              <div style={{ fontSize: 12, color: "#777" }}>
                                Post fee: ¥
                                {order.creationTime1688 &&
                                order.creationTime1688.postFee
                                  ? order.creationTime1688.postFee
                                  : 0}
                              </div>
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td></td>
                          <td></td>
                          <td>Total</td>
                          <td>¥{this.state.totalRmbToPay || 0}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {this.state.link && (
                    <div>
                      Payment Link:{" "}
                      <a href={this.state.link} target="_blank">
                        {this.state.link}
                      </a>
                    </div>
                  )}
                </div>
              )}

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                {this.state.link ? (
                  <button
                    type="button"
                    className="btn "
                    data-dismiss="modal"
                    style={{ background: "green", color: "white" }}
                  >
                    Link Generated!
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn "
                    style={{
                      backgroundColor: "red",
                      color: "white",
                      cursor: "pointer",
                    }}
                    // data-dismiss="modal"
                    onClick={async () => {
                      const orderIdList = this.state.orders.map((order) => {
                        return order.orderNumber;
                      });
                      console.log(orderIdList);
                      let link = await generate1688PaymentLink(orderIdList);
                      if (!link) {
                        notifyError("Link generation failed!");
                        return;
                      }
                      // here create a document inside paymentLinks1688 and update all the orders with paymentLink1688 field
                      if (
                        this.state.totalRmbToPay &&
                        this.state.orders &&
                        link
                      ) {
                        console.log(
                          "update order with payment is getting called!",
                        );
                        await this.props.updateOrdersWithPaymentLinkRedux(
                          this.state.totalRmbToPay,
                          this.state.orders,
                          link,
                        );
                      } else {
                        notifyWarning("One of the Data is missing");
                      }

                      this.setState({
                        link: link,
                      });
                    }}
                  >
                    Generate Link
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allUsers: state.users.users,
    currency: state.users.currency,
    orderTracking: state.orders.orderTracking,
    currentAdmin: state.admins.currentAdmin,
    employees: state.employees.employees,
  };
};
export default connect(mapStateToProps, {
  getOrderTrackingResultRedux,
  updateOrderApiRedux,
  deleteOrderApiRedux,
  updateOrdersWithPaymentLinkRedux,
  uploadCashInRedux,
})(Datatable);
